import { render, staticRenderFns } from "./user-customer.vue?vue&type=template&id=0ec5b6ee&scoped=true"
import script from "./user-customer.vue?vue&type=script&lang=js"
export * from "./user-customer.vue?vue&type=script&lang=js"
import style0 from "./user-customer.vue?vue&type=style&index=0&id=0ec5b6ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec5b6ee",
  null
  
)

export default component.exports